"use client"
import React, {useState, useRef, useEffect} from 'react'
import useIntersectionObserver from "@react-hook/intersection-observer";
import {useAxios} from "hooks/useAxios";
import {useRouter} from "next/navigation";
import ContentListItem from "../ContentListItem/ContentListItem";
import {CgSpinner} from "react-icons/cg";
import {useTekstClient} from "hooks/useTekstClient";
import useGebruiker from "hooks/useGebruiker";
import {useSearchParams} from 'next/navigation'
import {useFormTitle} from "../../../../hooks/useFormTitle";

export const ContentLijst = ({kennisItems, page, setSize, isLoading, isLoadingMore, isReachingEnd, mutate}) => {
    const searchParams = useSearchParams()
    const weergaveCompact = searchParams.get('cpt') === "1"
    const {ingelogdeGebruiker} = useGebruiker()
    const refToggle = useRef()
    const [ref, setRef] = useState()
    const {isIntersecting} = useIntersectionObserver(ref)
    const {tekst, isLoadingTekst} = useTekstClient()
    const router = useRouter()
    const {get} = useAxios()
    const {formTitle} = useFormTitle()

    useEffect(() => {
        if (!isIntersecting || isLoadingMore) return
        setSize(page+1);
    }, [isIntersecting])

    const handleBookmark = (id) => {
        get(`wiki/item/bookmark/${id}`)
            .then((result) => {
                mutate()
            }).catch()
            .finally();
    }

    // The forwardRef is important!!
    // Dropdown needs access to the DOM node in order to position the Menu
    const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
        <a href="" ref={refToggle} onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}>{children}</a>
    ));

    const handleOpenInNieuwVenter = (item) => {
        window.open(`/mijn-mkg/support/kenniscentrum/id/${item.id}/${formTitle(item.content_gepubliceerd?.titel)}`, '_blank');
    }

    const handleBewerken = (item) => {
        if (item.wiki_vorm_id === 19) {
            router.push(`/mijn-mkg/beheer/content-management/content/mail/${item.id}`)
        } else if (item.wiki_vorm_id === 10) {
            router.push(`/mijn-mkg/beheer/content-management/content/media/${item.id}`)
        } else {
            router.push(`/mijn-mkg/beheer/content-management/content/${item.id}`)
        }
    }

    return <ul className={`col-span-9 list-none`}>

        {kennisItems.map((page) => {
            return page.data?.map((item) => {
                return <ContentListItem weergaveCompact={weergaveCompact} ingelogdeGebruiker={ingelogdeGebruiker}
                                        item={item}
                                        handleBookmark={handleBookmark} handleBewerken={handleBewerken}
                                        handleOpenInNieuwVenter={handleOpenInNieuwVenter} CustomToggle={CustomToggle}
                                        searchParams={searchParams}/>
            })
        })}

        {!isReachingEnd && <li className={`flex flex-col items-center justify-center gap-2`} ref={setRef}>
            {<CgSpinner className={`animate-spin text-4xl text-kleur-donker-blauw`}/>}

            <div className={`animate-bounce ml-2`}>{tekst(`algemeen:laden`)}</div>
        </li>}


    </ul>

}